//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.HorizontalReference.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDistancePatternSpacing.js";
import "../no/Expression.js";
let d=[[[0,"DirectionType",1,0],[1,"HorizontalRef",0,"GeometricUtilities.HorizontalReference",0],[1,"NumberOfTurns",0,"Expression",0],[1,"PitchAlongSpiral",0,"GeometricUtilities.OnPathDistancePatternSpacing",0],[1,"RadialPitch",0,"Expression",0],[0,"SizeSpiralType",1,0],[0,"SpiralNormal",1,"Direction",0],[1,"TotalAngle",0,"Expression",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.SpiralPattern = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.SpiralPattern";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.SpiralPattern.OrientType = Object.freeze({
    "Lefthand" : "Lefthand", "Righthand" : "Righthand"});

SPLM.GeometricUtilities.SpiralPattern.SpiralDefineSize = Object.freeze({
    "NumberOfTurns" : "NumberOfTurns", "TotalAngle" : "TotalAngle"});

export default SPLM;